import { graphql } from "gatsby";
import React from "react";
import SuccessStoriesCarousel from "../../../components/SuccessStoriesCarousel/SuccessStoriesCarousel";
import type { SuccessStoryCarouselItemProps } from "../../../components/SuccessStoriesCarousel/SuccessStoriesCarouselItem/SuccessStoriesCarouselItem";
import { Colours } from "../../../utils/colours";
import WrappedSection from "../../WrappedSection/WrappedSection";
import * as styles from "./ParagraphSuccessStories.module.scss";
interface ParagraphSuccessStoriesProps {
	ourStories: SuccessStoryCarouselItemProps[];
}
export const getParagraphSuccessStoriesProps = (
	data: Queries.ParagraphSuccessStoriesDataFragment,
): ParagraphSuccessStoriesProps => ({
	ourStories: data.relationships.field_success_story.map((story) => ({
		title: story.field_heading,
		date: story.field_date,
		dogName: story.field_dog_name,
		imgSrc: story.relationships.field_featured_image.field_media_image.uri,
		imgAlt: story.relationships.field_featured_image.field_media_image.alt,
		storyText: story.field_text.value,
	})),
});
export const ParagraphSuccessStories: React.FC<
	ParagraphSuccessStoriesProps
> = ({ ourStories }) => {
	return (
		<WrappedSection
			sectionName="ParagraphSuccessStories"
			sectionColour={Colours.SANDY_FUR}
		>
			<div className={styles.parasuccessstoriesinner}>
				<SuccessStoriesCarousel stories={ourStories} />
			</div>
		</WrappedSection>
	);
};

export const fragment = graphql`
    fragment ParagraphSuccessStoriesData on paragraph__success_stories {
        __typename
        id
        relationships {
            field_success_story {
                ...ParagraphSuccessStoryData
            }
        }
    }

    fragment ParagraphSuccessStoryData on paragraph__success_story {
        __typename
        id
        field_heading
        field_dog_name
        field_date
        field_text {
            value
        }
        relationships {
            field_featured_image {
                ...MediaImageData
            }
        }
    }
`;
